export default __webpack_public_path__ + "static/media/Sovereign Battleblade.6302d691.jpg";